import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Button, IconButton, Tooltip } from '@mui/material';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { useGetYearMetricsQuery } from '../../../../../services/PaymentToolApi';

import ConfirmationModal from '../../../../../components/basicModalConfirmation';
import { useNotification } from '../../../../../context/NotificationContext';
import { useClosePeriodMutation } from '../../../../../services/PaymentToolApi';
import { createErrorMessage, formatMoney, getPeriodStatusComp } from '../../../../../utils';
import { getPeriodStatus } from "../../../../../utils";
import SendPaymentsModal from '../components/SendPaymentsModal';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useHistory } from 'react-router-dom';

export default function PaymentsByYearTable({ selectedYear, setSelectPeriod }) {

  const { showNotification } = useNotification();
  
  const history = useHistory();
  const { data, error, isLoading, isFetching } = useGetYearMetricsQuery({ year: selectedYear }, { skip: !selectedYear });
  const [initClosePeriod, { error: closePeriodError, isLoading: closePeriodIsLoading }] = useClosePeriodMutation();
  const [periodModalIsOpen, setPeriodModalIsOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState({});
  const [snackBarProp, setSnackBarProp] = React.useState({
    snackBarOpenProp: false, status: 'OK', text: 'Period Closed Successfully!'
  });
  const [sendPaymentsModalIsOpen, setSendPaymentsModalIsOpen] = React.useState(false);

  async function handleClosePeriod() {
    try {
      console.log("selected row: ", selectedRow);
      let res = await initClosePeriod({ period: selectedRow.periodDate }).unwrap();
      console.log("close period response: ", res);
      showNotification('Period Closed Successfully!', 'success');
    } catch (e) {
      console.log("error closing period: ", e);
      showNotification(createErrorMessage(e), 'error');
    }
  }

  function getActionButtons(params) {
    

    function onCurrentClick() {
      console.log(params.row)
      setSelectPeriod(params.row.periodDate);
    }

    function onPaymentInformationClick(){
      let periodID = params.row.periodID;
      history.push(`/dashboard/admintools?tab_index=4&showPeriodPaymentInformation=${periodID}`);
    }

    let statusName = getPeriodStatus(params.row);
    switch (statusName) {
      case "PENDING":
        return (
          <Tooltip title="Complete this period" placement="top-start">
            <IconButton color="primary" onClick={() => { setPeriodModalIsOpen(true); setSelectedRow(params.row) }}>
              <CheckOutlinedIcon />
            </IconButton>
          </Tooltip>
        );
      case "COMPLETED":
        // The Admin can only send the request to PayPal only once,
        //  if it fails for some reason we must report the error 
        //  and allow the Admin to send it again.
        return (
          params.row.synchronizedWithPayPal ?
              <Tooltip title="View Payment Information" placement="top-start">
              <IconButton color="primary" onClick={onPaymentInformationClick}>
                <InfoOutlinedIcon />
              </IconButton>
            </Tooltip>
            :
            <Tooltip title="Send payments to PayPal" placement="top-start">
               {/* periods before 2024-05-13 (we use 19 because es the end Date) are disabled because were payed manually */}
              <IconButton disabled={new Date(params.row.periodDate.split('-')[1].trim()) < new Date(2024, 4, 19)} color="primary" onClick={()=> setSendPaymentsModalIsOpen(params.row)}>
                <SendOutlinedIcon />
              </IconButton>
            </Tooltip>
        );
      default:
        return (
          <Tooltip title="Go to current period" placement="top-start">
            <IconButton color="primary" onClick={onCurrentClick}>
              <OpenInNewOutlinedIcon />
            </IconButton>
          </Tooltip>
        );
    }
  }

  if (error) {
    return <p>Error: {JSON.stringify(error)}</p>
  }

  const columns = [
    {
      field: 'periodDate',
      headerName: 'PERIOD DATE',
      flex: 1,
    },
    {
      field: 'statusName',
      headerName: 'STATUS',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => getPeriodStatusComp(params.row),
    },
    {
      field: 'rewardCount',
      headerName: 'REWARDS',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'bonusCount',
      headerName: 'BONUSES',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'royaltyCount',
      headerName: 'ROYALTIES',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'deductionCount',
      headerName: 'ADJUSTMENTS',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        return params.row.deductionCount + params.row.penaltyCount;
      }
    },
    {
      field: 'totalCount',
      headerName: 'TRANSACTIONS',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'amount',
      headerName: 'AMOUNT',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      // valueGetter: (params) => {
      //   return formatMoney(params.row.amount)
      // }
      renderCell: (params) => {
        const formattedAmount = formatMoney(params.row.amount || 0);
        return formattedAmount.includes('-') ? <p style={{ color: 'red' }}>{formattedAmount}</p> : formattedAmount;
      },
    },
    {
      field: 'buttons',
      headerName: '',
      width:50,
      headerAlign: 'center',
      align: 'center',
      renderCell: getActionButtons
    },
  ];

  const sortedRows = [...(data || [])].sort((a, b) => {
    const statusA = getPeriodStatus(a);
    const statusB = getPeriodStatus(b);
    
    if (statusA === "CURRENT" && statusB !== "CURRENT") {
      return -1;
    } else if (statusB === "CURRENT" && statusA !== "CURRENT") {
      return 1;
    } else {
      const startDateA = getStartDate(a);
      const startDateB = getStartDate(b);
  
      return new Date(startDateB) - new Date(startDateA);
    }
  });
  function getStartDate(obj) {
    if (obj?.periodDate) {
      const [startDate] = obj.periodDate.split('-');
      return startDate.trim();
    } else if (obj?.startDate) {
      return obj.startDate;
    }
  }
  
  return (
    <Box sx={{
      height: "60vh",
      width: '100%',
      '& .MuiDataGrid-row': {
        borderBottom: '2px solid #f2f2f2',
      },
    }}
    >
      <SendPaymentsModal open={sendPaymentsModalIsOpen} setOpen={setSendPaymentsModalIsOpen} periodID={ sendPaymentsModalIsOpen.periodID }  />
      <DataGridPremium
        sx={{ borderRadius: "0 0 1em 1em", backgroundColor: 'white', padding: '0 1em', '& .MuiBadge-badge': { display: 'none' }, }}
        headerHeight={40}
        rowHeight={36}
        // rows={[...(data || [])].reverse() || []}
        rows={sortedRows}
        loading={isLoading || isFetching}
        columns={columns}
        getRowId={(row) => row.periodDate}

        disableRowSelectionOnClick
      />

      <ConfirmationModal
        title={"Are you sure you want to close these Period?"}
        onClick={handleClosePeriod}
        handleClose={() => {
          setPeriodModalIsOpen(false);
        }}
        open={periodModalIsOpen}
        cancelLabel="No"
        confirmLabel="Yes"
      />

    </Box>
  );
}